import React from "react";
import FullCalendar from "@fullcalendar/react";
import type { CalendarOptions } from "@fullcalendar/core";
import "./OmniCalendar.css";

type OmniCalendarProps = CalendarOptions & {
  containerClassName?: string;
};

const OmniCalendar = React.forwardRef<FullCalendar, OmniCalendarProps>(
  ({ containerClassName = "fc-omnisport", ...calendarProps }, ref) => {
    return (
      <div className={containerClassName}>
        <FullCalendar ref={ref} {...calendarProps} />
      </div>
    );
  }
);

OmniCalendar.displayName = "OmniCalendar";

export default OmniCalendar;
